import { WDModel } from './wd-model.js';
import WDApi from './fetch/wd-api';

export default class WDStorage extends WDModel
{
	#data = null;

	constructor(data)
	{
		super(data);

		sessionStorage.wdStorage = (typeof data !== 'undefined') ? JSON.stringify(data) : '{}';
		sessionStorage.dbStorage = sessionStorage.wdStorage;
	};
	
	set(target, prop, receiver)
	{
		super.set(target,prop,receiver);

		//update the underlying storage
		this.#data[key] = target[prop];
		sessionStorage.wdStorage = JSON.stringify(this.#data);

		//push our change to the db
		const p = new WDApi('/accounts/storage');
		p[key] = target[prop];
		return p.post();
	};
	
	destroy()
	{
		this.#data = null;
	}
};

